import BaseService from "./geral/BaseService";

const base = "AgendVgm";

export default class AgendVgmService extends BaseService {
  constructor() {
    super(base);
  }

  listar(container, dataInicial, dataFinal) {
    let filtros = [];
    if (container) filtros.push(`container=${container}`);
    if (dataInicial) filtros.push(`dataInicial=${dataInicial}`);
    if (dataFinal) filtros.push(`dataFinal=${dataFinal}`);

    const str = filtros.reduce(
      (accumulator, currentValue) =>
        accumulator.concat(currentValue).concat("&"),
      "?"
    );
    return this.httpGet(`/${base}${str}`);
  }

  adicionarSolicitacao = model => {
    return this.httpPost(`/${base}`, model);
  };
}



// WEBPACK FOOTER //
// ./src/services/AgendVgmService.js